import React from 'react';

import type { CardData } from 'types/story';
import { useDidMount } from 'common/components/useDidMount';
import { CardFacade, StoryFacade } from 'common/utils/facades';
import { useClientSelector, useClientDispatch } from 'client/reducers';
import { selectStory } from 'client/reducers/story/selectors';
import { selectUser } from 'client/reducers/user/selectors';
import { getCardVotes } from 'client/actions/api';
import { updateAnswers } from 'src/routes/client/actions';
import { StoryHistory } from 'client/utils';
import { StoryCard } from '../StoryCard';

const Container: React.FC<{ children: React.ReactNode; card: CardData }> = ({ children, card }) => {
	const story = useClientSelector(selectStory)!;
	const { gameResponse } = useClientSelector(selectUser);
	const dispatch = useClientDispatch();

	useDidMount(() => {
		forceAnswersUpdate();

		async function forceAnswersUpdate() {
			const SF = new StoryFacade(story);
			const CF = new CardFacade(card);
			const { cardId } = CF;
			const { storyId } = SF;
			const showResults = CF.getShowResults(SF.settings);
			const oncePerUser = Boolean(SF.settings.restrictions?.oncePerUser);
			const hasPlayed = Boolean(gameResponse?.[cardId]);

			if (showResults && oncePerUser && hasPlayed) {
				const lsHistory = new StoryHistory({ storyId });
				const cardAnswers = lsHistory.cardsPlayed?.find(([_cardId, _]) => _cardId === cardId)?.[1]?.answers;

				if (cardAnswers?.length) {
					const answersMax = CardFacade.getAnswersMax(CF.type, SF.settings.cards?.[cardId]);
					const isMultipleAnswers = answersMax > 1;

					(isMultipleAnswers ? cardAnswers : cardAnswers.slice(0, 1)).forEach(({ id: answerId }) => {
						dispatch(
							updateAnswers({
								cardId,
								answerId,
							})
						);
					});

					if (isMultipleAnswers) {
						dispatch(updateAnswers({ cardId, submitted: true }));
					}

					// Update votes after marking the chosen answer(s), as this operation might be time-consuming
					const votes = await dispatch(getCardVotes({ cardId, storyId }));
					if (votes) dispatch(updateAnswers({ cardId, votes }));
				}
			}
		}
	});

	return children;
};

class PollCard extends StoryCard {
	render() {
		return (
			<Container card={this.props.data}>
				<div className="poll-card">{super.renderCard()}</div>
			</Container>
		);
	}
}

export default PollCard;
